  <div class="alert-default clearfix {{t type}} {{#unless visibility}}hidden-accessible-text{{/unless}}" role="alert">
     {{> icon icon_class=ico }}
     <div class="content-container">
       <h3 class="alert-title">{{t title}}</h3>
       <p class="alert-message">{{t body}}</p>
     </div>
     
     <button type="button" class="alert-close close" aria-label="{{t 'closeModal'}}">
          {{>icon uuid=cid prefix="fal" name="fa-times" size="fa-lg"}}
          <span class="screen-reader-content">{{t 'closeModal'}}</span>
      </button>
     
  </div>
